import { render, staticRenderFns } from "./edit_button.vue?vue&type=template&id=11891380&scoped=true&"
import script from "./edit_button.vue?vue&type=script&lang=js&"
export * from "./edit_button.vue?vue&type=script&lang=js&"
import style0 from "./edit_button.vue?vue&type=style&index=0&id=11891380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11891380",
  null
  
)

export default component.exports